module.exports = __webpack_public_path__ + "static/media/008-estonia.960d82ac.svg";